import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonModule } from '@angular/common';
import { AuthService } from '../core/services/authentication/auth.service';


@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    imports: [
        CommonModule
    ],
    styleUrls: ['./auth-callback.component.scss']
})
export class AuthCallbackComponent implements OnInit {

  error: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  async ngOnInit() {

    try {

      // check for error
      if (this.route.snapshot.fragment.indexOf('error') >= 0) {
        this.error = true;
        return;
      }

      await this.authService.completeAuthentication();
      this.runApp();

    } catch (error) {
      window.location.replace(window.location.origin);
      // this.appIntroService.initErrorToggle();

    }


  }

  runApp() {
    this.router.navigate(['/']);
  }

}
